import React from 'react'
const NotFound = () => {

    return (
        <>  <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
            <div className="auth-page-content overflow-hidden p-0">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="text-center">
                            <h3 className="text-uppercase">Sorry, Page not Found</h3>
                            <p className="text-muted mb-4">The page you are looking for not available!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default NotFound